import { UserRound } from 'lucide-react'
import { useContext, useState } from 'react'

import BrokerContext from 'components/context/BrokerContext'
import { useGetBrokers } from 'components/hooks/needs_attention/useGetBrokers'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndExactValueCallback } from './utils'

const AssigneesFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const { data } = useGetBrokers()
  const brokers = data?.data
  const { currentBroker } = useContext(BrokerContext)
  const { defaultPinnedOptions = [] } = props

  const pinnedBrokerOptions: ComboboxFilterOption<string>[] = [
    ...(currentBroker
      ? [
          { label: currentBroker?.broker_name, value: currentBroker?.id },
          ...defaultPinnedOptions,
        ]
      : defaultPinnedOptions),
  ]

  const brokerOptions: ComboboxFilterOption<string>[] =
    brokers
      ?.map((tag) => ({
        label: tag.broker_name,
        value: tag.id,
      }))
      .filter((option) => option.value !== currentBroker?.id) || []

  const filteredPinnedBrokerOptions = pinnedBrokerOptions.filter(
    filterByLabelAndExactValueCallback(query)
  )
  const filteredBrokerOptions = brokerOptions.filter(
    filterByLabelAndExactValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          { groupLabel: 'Pinned', options: filteredPinnedBrokerOptions },
          { groupLabel: 'Brokers', options: filteredBrokerOptions },
        ]}
        placeholder='Search brokers to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={[...pinnedBrokerOptions, ...brokerOptions]}
          noSelectionText='Assignee'
          pluralIdentifier='assignees'
        >
          <UserRound size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default AssigneesFilter
